module.exports = __webpack_public_path__ + "img/big-ofd.708855ca.png";